var map = {
	"./brownnoise.ogg": 150,
	"./coffee.ogg": 151,
	"./fan.ogg": 152,
	"./fire.ogg": 153,
	"./forest.ogg": 154,
	"./leaves.ogg": 155,
	"./lunchtime-lounge.mp3": 156,
	"./morning-murmur.mp3": 157,
	"./paris-paradise.mp3": 158,
	"./pinknoise.ogg": 159,
	"./rain.ogg": 160,
	"./seaside.ogg": 161,
	"./summernight.ogg": 162,
	"./thunderstorm.ogg": 163,
	"./train.ogg": 164,
	"./university-undertones.mp3": 165,
	"./water.ogg": 166,
	"./waterstream.ogg": 167,
	"./whitenoise.ogg": 168,
	"./wind.ogg": 169
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 149;